import {signal} from "@preact/signals-react";

export const productPagesDetailsIsEmpty = signal(false)
export const productPagesModalData = signal({})

export const productPagesDetailsReportFormIsOpen = signal(false)
export const productPagesDetailsSubmittedFilters = signal({})